export const DESIGNATIONS_RESET_STATE = 'DESIGNATIONS_RESET_STATE';
export const DESIGNATIONS_CURRENT_ITEM = 'DESIGNATIONS_CURRENT_ITEM';

export const DESIGNATIONS_REQUEST_LOADING = 'DESIGNATIONS_REQUEST_LOADING';
export const DESIGNATIONS_REQUEST_SUCCESS = 'DESIGNATIONS_REQUEST_SUCCESS';
export const DESIGNATIONS_REQUEST_FAILED = 'DESIGNATIONS_REQUEST_FAILED';

export const DESIGNATIONS_CURRENT_ACTION = 'DESIGNATIONS_CURRENT_ACTION';
export const DESIGNATIONS_RESET_ACTION = 'DESIGNATIONS_RESET_ACTION';